import { PAT } from "@/constants/testIds";
import { NEW_ENCOUNTER_BUTTON } from "@/lib/patientChartNewEncounter";

export default function RecentEncountersActions({ onNewEncounter, onViewAll }) {
  return (
    <div className="flex items-center gap-3">
      {onNewEncounter ? (
      <button
        type="button"
        data-testid={NEW_ENCOUNTER_BUTTON.testId}
        onClick={onNewEncounter}
        className="text-xs font-medium text-[#1E79E8] hover:text-[#1E79E8] hover:underline"
      >
        {NEW_ENCOUNTER_BUTTON.label}
      </button>
      ) : null}
      {onViewAll ? (
      <button
        type="button"
        data-testid={PAT.chartViewAllEncounters}
        onClick={onViewAll}
        className="text-xs font-medium text-[#1E79E8] hover:text-[#1E79E8] hover:underline"
      >
        View all
      </button>
      ) : null}
    </div>
  );
}
